module.exports = __webpack_public_path__ + "media/images/svg-icon/components-ad1b6cf68cab59d70c74fcc378989a44.svg";